import React, { useRef } from 'react'
import cn from 'utils/cn'

import { MotusIconType } from 'core/components/motus-icons/motus-types'

import Home from './svg/home.svg?react'
import HomeOutline from './svg/home-outline.svg?react'
import Car from './svg/car.svg?react'
import CarOutline from './svg/car-outline.svg?react'
import Clipboard from './svg/clipboard.svg?react'
import ClipboardOutline from './svg/clipboard-outline.svg?react'
import Team from './svg/team.svg?react'
import TeamOutline from './svg/team-outline.svg?react'
import Gear from './svg/gear.svg?react'
import GearOutline from './svg/gear-outline.svg?react'
import Gps from './svg/gps.svg?react'
import Helmet from './svg/helmet.svg?react'
import HelmetOutline from './svg/helmet-outline.svg?react'
import Report from './svg/report.svg?react'
import ReportsOutline from './svg/report-outline.svg?react'
import Csv from './svg/csv.svg?react'
import CsvOutline from './svg/csv-outline.svg?react'
import PersonalLockedOutline from './svg/personal-locked-outline.svg?react'
import PersonalLocked from './svg/personal-locked.svg?react'
import MapOutline from './svg/map-outline.svg?react'
import Map from './svg/map.svg?react'
import BriefcaseOutline from './svg/briefcase-outline.svg?react'
import Briefcase from './svg/briefcase.svg?react'
import EyeSlashOutline from './svg/eye-slash-outline.svg?react'
import EyeOpenOutline from './svg/eye-open-outline.svg?react'
import WarningCircle from './svg/warning-circle.svg?react'
import WarningCircleOutline from './svg/warning-circle-outline.svg?react'
import RoadOutline from './svg/road-outline.svg?react'
import CrossCircleOutline from './svg/cross-circle-outline.svg?react'
import CrossCircle from './svg/cross-circle.svg?react'
import CheckCircleOutline from './svg/check-circle-outline.svg?react'
import CheckCircle from './svg/check-circle.svg?react'
import Heart from './svg/heart.svg?react'
import HeartOutline from './svg/heart-outline.svg?react'
import Edit from './svg/edit.svg?react'
import PlayOutline from 'core/components/motus-icons/svg/play-outline.svg?react'
import PlayCircleOutline from 'core/components/motus-icons/svg/play-circle-outline.svg?react'
import Play from './svg/play.svg?react'
import PauseOutline from './svg/pause-outline.svg?react'
import RewindOutline from './svg/rewind-outline.svg?react'
import CloseCircle from './svg/close-circle.svg?react'
import RiskOutline from './svg/risk-outline.svg?react'
import WebinarOutline from './svg/webinar-outline.svg?react'
import Download from './svg/download.svg?react'
import Filter from './svg/filter.svg?react'
import FilterOutline from './svg/filter-outline.svg?react'
import ClapperBoardOutline from './svg/clapperboard-outline.svg?react'
import ClapperBoard from './svg/clapperboard.svg?react'
import CalendarOutline from './svg/calendar-outline.svg?react'
import TagOutline from './svg/tag-outline.svg?react'
import MergeOutline from './svg/merge-outline.svg?react'
import TrashOutline from './svg/trash-outline.svg?react'
import WarningTriangle from './svg/warning-triangle.svg?react'

const Icons: Record<
  MotusIconType,
  React.ComponentType<React.SVGProps<SVGSVGElement>>
> = {
  [MotusIconType.home]: Home,
  [MotusIconType['home-outline']]: HomeOutline,
  [MotusIconType.car]: Car,
  [MotusIconType['car-outline']]: CarOutline,
  [MotusIconType.clipboard]: Clipboard,
  [MotusIconType['clipboard-outline']]: ClipboardOutline,
  [MotusIconType.team]: Team,
  [MotusIconType['team-outline']]: TeamOutline,
  [MotusIconType.gear]: Gear,
  [MotusIconType['gear-outline']]: GearOutline,
  [MotusIconType.gps]: Gps,
  [MotusIconType.helmet]: Helmet,
  [MotusIconType['helmet-outline']]: HelmetOutline,
  [MotusIconType.report]: Report,
  [MotusIconType['report-outline']]: ReportsOutline,
  [MotusIconType.csv]: Csv,
  [MotusIconType['csv-outline']]: CsvOutline,
  [MotusIconType['personal-locked-outline']]: PersonalLockedOutline,
  [MotusIconType['personal-locked']]: PersonalLocked,
  [MotusIconType['map-outline']]: MapOutline,
  [MotusIconType['map']]: Map,
  [MotusIconType['briefcase-outline']]: BriefcaseOutline,
  [MotusIconType['briefcase']]: Briefcase,
  [MotusIconType['eye-slash-outline']]: EyeSlashOutline,
  [MotusIconType['eye-open-outline']]: EyeOpenOutline,
  [MotusIconType['warning-circle']]: WarningCircle,
  [MotusIconType['warning-circle-outline']]: WarningCircleOutline,
  [MotusIconType['road-outline']]: RoadOutline,
  [MotusIconType['play-outline']]: PlayOutline,
  [MotusIconType['cross-circle-outline']]: CrossCircleOutline,
  [MotusIconType['cross-circle']]: CrossCircle,
  [MotusIconType['check-circle-outline']]: CheckCircleOutline,
  [MotusIconType['check-circle']]: CheckCircle,
  [MotusIconType['heart']]: Heart,
  [MotusIconType['heart-outline']]: HeartOutline,
  [MotusIconType['edit']]: Edit,
  [MotusIconType['rewind-outline']]: RewindOutline,
  [MotusIconType['pause-outline']]: PauseOutline,
  [MotusIconType['close-circle']]: CloseCircle,
  [MotusIconType['risk-outline']]: RiskOutline,
  [MotusIconType['webinar-outline']]: WebinarOutline,
  [MotusIconType['play-circle-outline']]: PlayCircleOutline,
  [MotusIconType.play]: Play,
  [MotusIconType['download']]: Download,
  [MotusIconType['filter']]: Filter,
  [MotusIconType['filter-outline']]: FilterOutline,
  [MotusIconType['clapperboard-outline']]: ClapperBoardOutline,
  [MotusIconType['clapperboard']]: ClapperBoard,
  [MotusIconType['calendar-outline']]: CalendarOutline,
  [MotusIconType['tag-outline']]: TagOutline,
  [MotusIconType['merge-outline']]: MergeOutline,
  [MotusIconType['trash-outline']]: TrashOutline,
  [MotusIconType['warning-triangle']]: WarningTriangle
}

export interface MotusIconProps {
  /**
   * Name of the icon to render.
   */
  name: `${MotusIconType}`
  /**
   * Width of the icon (overrides default SVG width).
   */
  width?: string | number
  /**
   * Height of the icon (overrides default SVG height).
   */
  height?: string | number
  /**
   * Size of the icon (overrides both width and height).
   */
  size?: string | number
  /**
   * Additional class names for the icon.
   */
  className?: string
  /**
   * ID for the icon element.
   */
  id?: string
  /**
   * Color class for the icon (e.g., 'text-primary').
   * Since SVGs now use currentColor, this will control the fill color.
   */
  color?: string
  /**
   * Click event handler for the icon.
   */
  onClick?: React.MouseEventHandler<SVGSVGElement>
  /**
   * Mouse down event handler for the icon.
   */
  onMouseDown?: React.MouseEventHandler<SVGSVGElement>
  /**
   * Optional title for accessibility.
   */
  title?: string
  /**
   * ARIA label for accessibility.
   */
  ariaLabel?: string
}

/**
 * MotusIcon component for rendering Motus-specific SVG icons.
 * Icons use currentColor for easy color customization via CSS.
 * Renders icons directly without wrapper elements for better performance.
 *
 * @example
 * ```tsx
 * <MotusIcon name={MotusIconType.home} size={24} color="text-primary" />
 * <MotusIcon name={MotusIconType.car} width={20} height={20} className="hover:opacity-80" />
 * ```
 */
const MotusIcon = ({
  name,
  height = 24,
  width = 24,
  size,
  className,
  id,
  color,
  onClick,
  onMouseDown,
  title,
  ariaLabel
}: MotusIconProps) => {
  const svgRef = useRef<SVGSVGElement>(null)
  const IconComponent = Icons[name]

  // Graceful fallback for invalid icon names
  if (!IconComponent) {
    console.warn(`MotusIcon: Icon "${name}" not found`)
    return null
  }

  return (
    <IconComponent
      height={size ?? height}
      width={size ?? width}
      id={id}
      className={cn(['transition-colors', color, className])}
      ref={svgRef}
      onClick={onClick}
      onMouseDown={onMouseDown}
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      data-title={title}
    />
  )
}

export default MotusIcon
